export default __webpack_public_path__ + "static/media/hero-bottom-vector.58ba34aa.svg";